import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Gamepad2, LayoutDashboard } from 'lucide-react';

const css = `
@media (max-width: 600px) {
  .nav-link-text { display: none !important; }
  .nav-brand { font-size: 1rem !important; }
  .nav-bar { padding: 8px 12px !important; }
}
`;

const S = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 20px',
    backgroundColor: 'var(--color-bg-secondary)',
    borderBottom: '1px solid rgba(212, 175, 55, 0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    gap: '8px',
  },
  brand: {
    fontFamily: 'var(--font-display)',
    fontSize: '1.3rem',
    fontWeight: 700,
    color: 'var(--color-primary)',
    textDecoration: 'none',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 14px',
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-text-secondary)',
    textDecoration: 'none',
    fontSize: '0.85rem',
    fontWeight: 500,
    transition: 'all var(--transition-fast)',
    minHeight: '44px',
  },
  linkActive: {
    color: 'var(--color-primary)',
    backgroundColor: 'rgba(212, 175, 55, 0.1)',
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-text-muted)',
    cursor: 'pointer',
    transition: 'all var(--transition-fast)',
    border: 'none',
    background: 'none',
    minHeight: '44px',
    minWidth: '44px',
  },
};

export default function Navbar() {
  const { user, logout, isAdmin, isOperator } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="nav-bar" style={S.nav}>
      <style>{css}</style>
      <Link to="/" className="nav-brand" style={S.brand}>
        PickBoxGame
      </Link>

      <div style={S.links}>
        {user && (
          <>
            {isOperator && (
              <Link
                to="/control"
                style={{
                  ...S.link,
                  ...(isActive('/control') ? S.linkActive : {}),
                }}
              >
                <Gamepad2 size={18} />
                <span className="nav-link-text">Partita</span>
              </Link>
            )}

            {isOperator && (
              <Link
                to="/admin"
                style={{
                  ...S.link,
                  ...(isActive('/admin') ? S.linkActive : {}),
                }}
              >
                <LayoutDashboard size={18} />
                <span className="nav-link-text">Pannello</span>
              </Link>
            )}

            <button
              style={S.logoutBtn}
              onClick={logout}
              onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--color-danger)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--color-text-muted)'; }}
              title="Esci"
            >
              <LogOut size={18} />
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
